import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import styled from 'styled-components'

import logoSrc from '@/assets/images/main_logo.png'
import rewardSrc from '@/assets/images/main-sec4-reward-icon.png'
import AwradReviewList from '@/features/home/components/MainAwradReviewList'
import { Nanum_eb_size } from '@/styles/font/NanumSquare'
import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'
import { icoSet } from '@/styles/mixins'

const MainAwardSection = () => {
  const awardTitleRef = useRef(null)
  const awardTitleInView = useInView(awardTitleRef, { once: true })

  const fadeVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  }

  return (
    <Section>
      <AwardBanner>
        <AwradTitle>
          <AwardImg
            ref={awardTitleRef}
            src={rewardSrc}
            alt="award img"
            variants={fadeVariants}
            initial="hidden"
            animate={awardTitleInView ? 'visible' : 'hidden'}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          />
          <span>2021 대한민국 모바일 대상</span>
          <br />
          스타트업 보안 부문{'\n'}
          <strong> ‘최우수상’ 수상</strong>
        </AwradTitle>
        <CompanyLogoImg src={logoSrc} alt="logos img" />
      </AwardBanner>
      <AwradReviewList />
    </Section>
  )
}

export default MainAwardSection

const Section = styled.section`
  padding: 90px 0 200px;
  margin: 0 auto;
  text-align: center;

  ${mediaTablet} {
    padding: 72px 0;
  }

  ${mediaMobile} {
    padding-left: 24px;
    padding-right: 24px;
  }
`
const AwardBanner = styled.div`
  margin-bottom: 40px;

  ${mediaTablet} {
    margin-bottom: 170px;
  }
`

const AwradTitle = styled.h4`
  word-break: keep-all;
  ${Nanum_eb_size(56)}
  font-weight: 700;
  color: var(--yellow);
  margin-bottom: 20px;

  span {
    ${Nanum_eb_size(36)}
    font-weight: 700;
    color: var(--black);
    padding: 18px 0 12px;
  }

  strong {
    ${Nanum_eb_size(56)}
    color: var(--orange);
  }

  ${mediaTablet} {
    ${Nanum_eb_size(38)}
    font-weight: 700;
    letter-spacing: -1.2px;
    margin-bottom: 50px;
    white-space: pre-line;

    span {
      ${Nanum_eb_size(24)}
      letter-spacing: -1.2px;
      padding: 24px 0 9px;
    }

    strong {
      ${Nanum_eb_size(38)}
    }
  }
`

const AwardImg = styled(motion.img)`
  width: 392px;
  height: 164px;
  margin: 0 auto;
  ${icoSet}

  ${mediaTablet} {
    width: 312px;
    height: 146px;
  }
`
const CompanyLogoImg = styled.img`
  width: 456px;
  height: 28px;
  margin: 0 auto;
  ${icoSet}

  ${mediaTablet} {
    width: 576px;
    height: 35px;
  }
  ${mediaMobile} {
    width: 288px;
    height: 18px;
  }
`
